import React from 'react'

const NewArrival:React.FC = () => {
  return (
    <div className='campaign__container'>
        <div className="campaign__wrapper">
            <img src="/img/widgets/new-arrival.png" alt=''/>
        </div>
    </div>
  )
}

export default NewArrival